import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail"]

  connect() {
    this.syncAll()
  }

  toggle(event) {
    const btn = event.currentTarget
    const parentRow = btn.closest("tr")
    if (!parentRow) return

    const detailRow = parentRow.nextElementSibling
    if (!detailRow) return

    const isOpen = !detailRow.classList.contains("hidden")

    if (isOpen) {
      this.hideDetail(detailRow)
      btn.textContent = "▶"
    } else {
      this.showDetail(detailRow)
      btn.textContent = "▼"
    }
  }

  hideDetail(detail) {
    detail.classList.add("hidden")
  }

  showDetail(detail) {
    detail.classList.remove("hidden")
  }

  syncAll() {
    document.querySelectorAll(".expand-btn").forEach((btn) => {
      const parentRow = btn.closest("tr")
      if (!parentRow) return

      const detailRow = parentRow.nextElementSibling
      if (!detailRow) return

      const isOpen = !detailRow.classList.contains("hidden")

      btn.textContent = isOpen ? "▼" : "▶"
    })
  }
  
  handleDelete(event) {
    const target = event.currentTarget

    const projectNumber = target.dataset.projectNumber
    const hasChild  = target.dataset.hasChild === "true"

    let msg = `現場番号 ${projectNumber} を削除します。`

    if (hasChild) {
      msg += "\nこの親事業に紐づく子事業も削除されます。"
    }

    msg += "\n現場別手当の設定も削除されます。"

    if (!confirm(msg)) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
  }
}
